import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatText(text) {
  if (!text) return "";
  // Mengubah literal "\n" atau "/n" menjadi karakter enter asli
  return text.toString()
    .replace(/\\n/g, "\n") // Handle \n (backslash n)
    .replace(/\/n/g, "\n"); // Handle /n (slash n) - jaga-jaga jika ada typo input
}